import { render, staticRenderFns } from "./MobilePlatform.vue?vue&type=template&id=f6cde090&scoped=true&"
import script from "./MobilePlatform.vue?vue&type=script&lang=js&"
export * from "./MobilePlatform.vue?vue&type=script&lang=js&"
import style0 from "./MobilePlatform.vue?vue&type=style&index=0&id=f6cde090&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6cde090",
  null
  
)

export default component.exports